import * as R from 'ramda';

const ts_translateJson = {
    wim: {
        "disponent": "abteilungsleiter",
        "owner-nr.": "ZSB-Nr.",
        "owner decription": "ZSB Beschreibung",
        "erp-nr.": "EZB-Nr.",
        "l. datum:": "Lieferdatum:",
        "arbeitsschritt": "Status",
        "erp-nummer": "Bauteilnummer",
        "order-nummer": "Bestellnummer",
    },
    soh: {
        "disponent": "disponent",
        "l. datum:": "Bis:",
        "owner-nr.": "ERP. Taskowner",
        "owner decription": "Beschreibung Taskowner",
        "order-nummer": "Bestellnummer",
    },
    default: {
        "disponent": "disponent",
        "l. datum:": "Bis:",
        "arbeitsschritt": "Schritt",
    }
};

export function ts_translate(value, capital = true, pure = false) {
    const client = process.env.CLIENT;
    let translation = "";

    if (ts_translateJson[client] !== undefined) {
        translation = ts_translateJson[client][R.toLower(value)];
    } else {
        translation = ts_translateJson["default"][R.toLower(value)]
    }

    if (pure) {
        return translation;
    }

    if (R.isEmpty(translation) || R.isNil(translation) || translation === undefined) {
        return value;
    }

    if (capital) {
        return translation.charAt(0).toUpperCase() + translation.slice(1)
    } else {
        return translation;
    }
}



// WEBPACK FOOTER //
// ./src/common/clientTranslate.js